import { polygon } from 'thirdweb/chains'
import { NetworkEnvironment } from '../types'
import environment from '../environment'

const subgraphApiKey = environment.subgraphApiKey

export const polygonEnvironment: NetworkEnvironment = {
  subgraphUrls: {
    main: 'https://gateway.thegraph.com/api/subgraphs/id/BHew5um8gNZkVHg4TrZSNUqHrtKT49PDqdEKtDgLqJp6',
    sx1155: `https://gateway-arbitrum.network.thegraph.com/api/${subgraphApiKey}/subgraphs/id/BxC2c8iaQA1y2QeeYGh2PBhMT44RvNvxkAKv8y6ZPBaa`,
    swarm: `https://gateway.thegraph.com/api/${subgraphApiKey}/subgraphs/id/5jyKcTX7beneokj6HnkMQXjJMcSooW8ZmE8evUYfQvsz`,
  },
  contracts: {
    dotcContractAddress: '0x3A5D3FB5d39dc5a206E9f63E133e2Ff1B7c2C159',
    dotcEscrowContractAddress: '0xef24A519994bffa2104c4fd6c1ee58718f6c7Bd5',
    smtDistributorAddress: '0x664f0D579109497e2eCEd75A9ad9314893aE27d2',
    carbonBundleAddress: '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89',
    carbonBundleStorageAddress: '0x2eF6D5dA60e1A7b9b243818f08B2F316d2258485',
  },
  tokens: {
    smt: '0xE631DABeF60c37a37d70d3B4f812871df663226f',
    usdce: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
    goldOz: '0xfb75d446e30842c8b7100014db7c5fd2cbfbc072', // NFT
    goldKg: '0x973b1894d688f2e45fe9c573ef19a8f519d32208', // NFT
    carbon: '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89',
    vicc: '0x2081A1792b15AB1373DcB3B1f181e190F0026446', // NFT
  },
}

export const polygonChainConfig = polygon
